import { makeVar } from '@apollo/client';
import { Rooms } from 'types/cache/Rooms';

const rooms: Rooms = {
  quantities: new Map(),
};

export const roomsVar = makeVar<Rooms>(rooms);
